import React, { useCallback } from "react";
import SearchFilterInput from "nlib/common/SearchFilterInput";
import useEnvVars from "hooks/useEnvVars";

const SearchFilter = ({ name, defaultValue, disabled, component: Component = SearchFilterInput, onChange, ...restProps }) => {
  const [{ [name]: value = defaultValue }, setEnvVars] = useEnvVars();

  const handleChange = useCallback((newValue) => {
    setEnvVars({ [name]: newValue || null });
    if (onChange) onChange(newValue);
  }, [name, onChange, setEnvVars]);

  return (
    <Component
      {...restProps}
      disabled={disabled}
      value={value}
      onChange={handleChange} />
  );
};

export default SearchFilter;
